import { render, staticRenderFns } from "./TheNavigationBase.vue?vue&type=template&id=4d5ee03c&"
import script from "./TheNavigationBase.vue?vue&type=script&lang=ts&"
export * from "./TheNavigationBase.vue?vue&type=script&lang=ts&"
import style0 from "./TheNavigationBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VList,VListItemGroup,VNavigationDrawer})
